meedy.config(['$stateProvider', '$urlRouterProvider', 'meedyConfig',
    function ($stateProvider, $urlRouterProvider, config) {

        // layout
        $stateProvider.state(Constant.STATE.PRE.MEEDY.LOGIN, {
            url: '^/meedy/login',
            controller: 'meedy.loginController',
            templateUrl: 'meedy/application/view/custom/meedy/pre/login.html',
            data: {module: Constant.MEEDY.MODULE.LOGIN}
        });

        $stateProvider.state(Constant.STATE.PRE.MEEDY.REMIND_PASSWORD, {
            url: '^/meedy/remind-password',
            controller: 'meedy.remindPasswordController',
            templateUrl: 'meedy/application/view/custom/meedy/pre/remind-password.html',
            data: {module: Constant.MEEDY.MODULE.LOGIN}
        });

        $stateProvider.state(Constant.STATE.PRE.MEEDY.VERIFICATION, {
            url: '^/meedy/verification/{uuid:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
            controller: 'meedy.verificationController',
            templateUrl: 'meedy/application/view/custom/meedy/pre/verification.html',
            data: {module: Constant.MEEDY.MODULE.LOGIN}
        });

        $stateProvider.state(Constant.STATE.PRE.MEEDY.CHANGE_PASSWORD, {
            url: '^/meedy/change-password/{uuid:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
            controller: 'meedy.changePasswordController',
            templateUrl: 'meedy/application/view/custom/meedy/pre/change-password.html',
            data: {module: Constant.MEEDY.MODULE.CHANGE_PASSWORD}
        });
			
    }
]);